export function isPlaceholderScannerSupported() {
  return typeof window !== 'undefined';
}
